import { useMemo } from 'react';
import { preFixImgUrl } from '@/utils';
import { isAppLocale, type AppLocale } from '@/constants/appLocale';
import { TEMP_COUPON_STORES, type CouponLocaleText, type TempCouponStore } from './couponListInfo';

export { COUPON_STATIC_TEXT, TEMP_COUPON_STORES, type CouponLocaleText, type TempCouponStore } from './couponListInfo';

export const TEMP_COUPON_PAGE_SIZE = 9

const getCouponLocale = (language: string | undefined): AppLocale => {
  if (language && isAppLocale(language)) return language
  return 'zh_CN'
}

const isChineseLocale = (language: string | undefined) => {
  const locale = getCouponLocale(language)
  return locale === 'zh_CN' || locale === 'zh_TW'
}

export function getCouponLocaleText(text: CouponLocaleText, language: string | undefined): string {
  return text[getCouponLocale(language)]
}

export function formatCouponParticipants(
  participantCount: string,
  participantsSuffix: CouponLocaleText,
  language: string | undefined,
): string {
  const suffix = getCouponLocaleText(participantsSuffix, language)
  return `${participantCount} ${suffix}`
}

/** 详情展示用最终图片 */
export function getTempCouponDetailImageFile(store: TempCouponStore, language: string | undefined): string {
  return isChineseLocale(language) ? store.detailImageZhFile : store.detailImageEnFile
}

export function getTempCouponById(id: string | null | undefined): TempCouponStore | undefined {
  if (!id) return undefined
  return TEMP_COUPON_STORES.find((s) => s.id === id)
}

export type CouponQuickLinkItem =
  | { key: string; iconImg: string; to: string }
  | { key: string; iconImg: string; href: string };

const COUPON_LIST_QUICK_LINKS = [
  {
    key: '00a5d8ee',
    iconFile: 'e62cca86d301cb431507da5775a49803.png',
    to: '/items',
  },
  {
    key: '487853f3',
    iconFile: '604ce17e39d715e03b02aba7b3874804.png',
    to: '/coupon-precautions',
  },
  {
    key: '2c7782ea',
    iconFile: '691e96c40a4369e0f941c4b9fdf709da.png',
    href: 'mailto:info.japanmall@jdxjp.net',
  },
] as const;

export default function useModel() {
  const quickLinks = useMemo<CouponQuickLinkItem[]>(
    () =>
      COUPON_LIST_QUICK_LINKS.map((row) => {
        const base = {
          key: row.key,
          iconImg: preFixImgUrl(row.iconFile),
        };
        if ('href' in row) {
          return { ...base, href: row.href };
        }
        return { ...base, to: row.to };
      }),
    [],
  );

  return { quickLinks };
}
